/**
 * Product page: subscription & buying area
 * - Injects Seal widget styles (Theme Editor: Playfair Display, label #305678 24px Medium, price #BE6D4B 20px Semibold).
 * - Toggles class .sh-subscription-one-time-selected on .product-form when one-time purchase is selected.
 * - Hides Seal "Purchase options label" (.) and "Every 4 weeks" by text content.
 * - Integrates with native selling plan select and Seal Subscriptions widget.
 */
(function () {
  var FORM_SELECTOR = '.thb-product-detail .product-form';
  var ONE_TIME_CLASS = 'sh-subscription-one-time-selected';
  var TEXTS_TO_HIDE = ['.', 'Every 4 weeks', '>', 'US', 'CAN', 'USD', 'CAD', 'NZ'];
  var CURRENCY_CODE_PREFIX = /^(US|CAN|USD|CAD|NZ)\s*/i;

  /* Read Theme Editor values from :root so labels/prices match Theme > Editor > Seal subscriptions widget */
  function getSealVars() {
    var s = window.getComputedStyle && window.getComputedStyle(document.documentElement);
    function get(key) { return (s && s.getPropertyValue && s.getPropertyValue(key).trim()) || ''; }
    return {
      label: {
        font: get('--seal-widget-label-font') || 'inherit',
        size: get('--seal-widget-label-font-size') || '24px',
        color: get('--seal-widget-label-color') || '#305678',
        weight: get('--seal-widget-label-font-weight') || '500'
      },
      price: {
        font: get('--seal-widget-price-font') || 'inherit',
        size: get('--seal-widget-price-font-size') || '20px',
        color: get('--seal-widget-price-color') || '#BE6D4B',
        weight: get('--seal-widget-price-font-weight') || '600'
      }
    };
  }

  function injectSealStyles() {
    if (document.getElementById('seal-theme-injected-styles')) return;
    var v = getSealVars();
    var style = document.createElement('style');
    style.id = 'seal-theme-injected-styles';
    style.textContent = [
      '.product-purchase-options-wrap .sls-purchase-options-container [class*="subscribe"], .product-purchase-options-wrap .sls-purchase-options-container .sls-selling-plan-label, .product-purchase-options-wrap .sls-purchase-options-container label, .product-purchase-options-wrap .sls-purchase-options-container [class*="title"]:not([class*="one-time"]), .product-purchase-options-wrap .sealsubs-container [class*="subscribe"], .product-purchase-options-wrap .sealsubs-container .sls-selling-plan-label, .product-purchase-options-wrap .sealsubs-container label, .product-purchase-options-wrap .sealsubs-container [class*="title"]:not([class*="one-time"]), .product-purchase-options-wrap .sls-option-container [class*="subscribe"], .product-purchase-options-wrap .sls-option-container .sls-selling-plan-label, .product-purchase-options-wrap .sls-option-container label, .product-purchase-options-wrap .sls-option-container [class*="title"]:not([class*="one-time"]), .sls-purchase-options-container [class*="subscribe"], .sls-purchase-options-container .sls-selling-plan-label, .sls-purchase-options-container label, .sls-purchase-options-container [class*="title"]:not([class*="one-time"]), .sealsubs-container [class*="subscribe"], .sealsubs-container .sls-selling-plan-label, .sealsubs-container label, .sealsubs-container [class*="title"]:not([class*="one-time"]), .sls-option-container [class*="subscribe"], .sls-option-container .sls-selling-plan-label, .sls-option-container label, .sls-option-container [class*="title"]:not([class*="one-time"]) { font-family: ' + v.label.font + ' !important; font-size: ' + v.label.size + ' !important; color: ' + v.label.color + ' !important; font-weight: ' + v.label.weight + ' !important; }',
      '.product-purchase-options-wrap .sls-purchase-options-container [class*="price"], .product-purchase-options-wrap .sls-purchase-options-container .price, .product-purchase-options-wrap .sls-purchase-options-container .sls-price, .product-purchase-options-wrap .sealsubs-container [class*="price"], .product-purchase-options-wrap .sealsubs-container .price, .product-purchase-options-wrap .sealsubs-container .sls-price, .product-purchase-options-wrap .sls-option-container [class*="price"], .product-purchase-options-wrap .sls-option-container .price, .product-purchase-options-wrap .sls-option-container .sls-price, .sls-purchase-options-container [class*="price"], .sls-purchase-options-container .price, .sls-purchase-options-container .sls-price, .sealsubs-container [class*="price"], .sealsubs-container .price, .sealsubs-container .sls-price, .sls-option-container [class*="price"], .sls-option-container .price, .sls-option-container .sls-price { font-family: ' + v.price.font + ' !important; font-size: ' + v.price.size + ' !important; color: ' + v.price.color + ' !important; font-weight: ' + v.price.weight + ' !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function applySealStylesToElements(container) {
    if (!container || !container.querySelectorAll) return;
    var v = getSealVars();
    container.querySelectorAll('[class*="price"], .price, .sls-price').forEach(function (el) {
      el.style.setProperty('font-family', v.price.font, 'important');
      el.style.setProperty('font-size', v.price.size, 'important');
      el.style.setProperty('color', v.price.color, 'important');
      el.style.setProperty('font-weight', v.price.weight, 'important');
    });
    /* Option labels: class-based + any label that wraps a radio (Subscribe & Save 10%, One time purchase) */
    container.querySelectorAll('[class*="subscribe"], .sls-selling-plan-label, [class*="title"], label').forEach(function (el) {
      if (el.className && typeof el.className === 'string' && el.className.indexOf('one-time') !== -1) return;
      if (el.tagName === 'LABEL' && !el.querySelector('input[type="radio"]')) return;
      el.style.setProperty('font-family', v.label.font, 'important');
      el.style.setProperty('font-size', v.label.size, 'important');
      el.style.setProperty('color', v.label.color, 'important');
      el.style.setProperty('font-weight', v.label.weight, 'important');
    });
  }

  function runSealStyling() {
    injectSealStyles();
    var wrap = document.querySelector('.product-purchase-options-wrap');
    var seal = document.querySelector('.sls-purchase-options-container, .sealsubs-container, .sls-option-container.seal-table, .sealsubs-target-element');
    if (wrap) applySealStylesToElements(wrap);
    if (seal) applySealStylesToElements(seal);
  }

  function hideSealElementsByText(container) {
    if (!container || !container.querySelectorAll) return;
    container.querySelectorAll('*').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (TEXTS_TO_HIDE.indexOf(text) !== -1) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  /* Hide Seal "Label for plan selector" – the label above the frequency dropdown (field is mandatory, hide the element that displays it) */
  function hidePlanSelectorLabel(container) {
    if (!container || !container.querySelectorAll) return;
    container.querySelectorAll('select').forEach(function (select) {
      var prev = select.previousElementSibling;
      if (prev && (prev.tagName === 'LABEL' || prev.tagName === 'SPAN' || prev.tagName === 'DIV' || prev.tagName === 'P')) {
        prev.style.setProperty('display', 'none', 'important');
      }
    });
  }

  /* Hide subscription disclaimer under buttons: "This item is a recurring or deferred purchase..." */
  function hideSubscriptionDisclaimer(container) {
    if (!container || !container.querySelectorAll) return;
    var key = 'This item is a recurring or deferred purchase';
    var candidates = [];
    container.querySelectorAll('*').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (text.indexOf(key) !== -1) candidates.push(el);
    });
    if (candidates.length) {
      candidates.sort(function (a, b) { return (a.textContent || '').length - (b.textContent || '').length; });
      candidates[0].style.setProperty('display', 'none', 'important');
    }
  }

  function runHideSealText() {
    var wrap = document.querySelector('.product-purchase-options-wrap');
    var seal = document.querySelector('.sls-purchase-options-container, .sealsubs-container, .sls-option-container.seal-table');
    if (wrap) {
      hideSealElementsByText(wrap);
      hidePlanSelectorLabel(wrap);
      hideSubscriptionDisclaimer(wrap);
    }
    if (seal) {
      hideSealElementsByText(seal);
      hidePlanSelectorLabel(seal);
      hideSubscriptionDisclaimer(seal);
    }
  }

  /* Strip national currency code (US, CAN, USD, CAD) from widget price display */
  function stripCurrencyCodeFromPrices(container) {
    if (!container || !container.querySelectorAll) return;
    container.querySelectorAll('[class*="price"], .price, .sls-price').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (CURRENCY_CODE_PREFIX.test(text)) {
        el.textContent = text.replace(CURRENCY_CODE_PREFIX, '');
      }
    });
  }

  function runStripCurrencyCode() {
    var wrap = document.querySelector('.product-purchase-options-wrap');
    var seal = document.querySelector('.sls-purchase-options-container, .sealsubs-container, .sls-option-container.seal-table');
    if (wrap) stripCurrencyCodeFromPrices(wrap);
    if (seal) stripCurrencyCodeFromPrices(seal);
  }

  /* Insert "Ships next day · Cancel anytime" below Subscribe line, above the frequency dropdown */
  function injectSubscriptionBenefits(container) {
    if (!container || container.querySelector('#sh-subscription-benefits')) return;
    var select = container.querySelector('select');
    if (!select || !select.parentElement) return;
    var parent = select.parentElement;
    var el = document.createElement('p');
    el.id = 'sh-subscription-benefits';
    el.className = 'sh-subscription-benefits';
    el.textContent = 'Ships next day · Cancel anytime';
    parent.parentNode.insertBefore(el, parent);
  }

  function runInjectBenefits() {
    var wrap = document.querySelector('.product-purchase-options-wrap');
    var seal = document.querySelector('.sls-purchase-options-container, .sealsubs-container, .sls-option-container.seal-table');
    if (wrap) injectSubscriptionBenefits(wrap);
    if (seal) injectSubscriptionBenefits(seal);
  }

  function runAll() {
    runSealStyling();
    runHideSealText();
    runStripCurrencyCode();
    runInjectBenefits();
  }

  function setOneTimeState(form, oneTimeSelected) {
    if (!form) return;
    if (oneTimeSelected) {
      form.classList.add(ONE_TIME_CLASS);
    } else {
      form.classList.remove(ONE_TIME_CLASS);
    }
  }

  function initNativeSellingPlan(form) {
    var select = form.querySelector('select[name="selling_plan"]');
    if (!select) return false;
    function update() {
      setOneTimeState(form, !select.value || select.value === '');
    }
    select.addEventListener('change', update);
    update();
    return true;
  }

  function initSealWidget(form) {
    var seal = form.querySelector('.sealsubs-target-element');
    if (!seal) return false;

    function isOneTimeSelected() {
      var radios = seal.querySelectorAll('input[type="radio"]');
      if (radios.length) {
        var checked = seal.querySelector('input[type="radio"]:checked');
        if (checked) {
          var label = (checked.closest('label') || checked.parentElement || {}).textContent || '';
          return /one\s*time|one-time/i.test(label);
        }
      }
      var sel = seal.querySelector('select');
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        var text = (opt && opt.textContent) || '';
        return /one\s*time|one-time/i.test(text) || sel.value === '' || sel.value === 'one-time';
      }
      return false;
    }

    function update() {
      setOneTimeState(form, isOneTimeSelected());
    }

    seal.addEventListener('change', update);
    seal.addEventListener('click', function (e) {
      setTimeout(update, 0);
    });
    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(update);
      obs.observe(seal, { childList: true, subtree: true });
    }
    setTimeout(update, 100);
    return true;
  }

  function init() {
    var form = document.querySelector(FORM_SELECTOR);
    if (form) {
      initNativeSellingPlan(form) || initSealWidget(form);
    }
    runAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('sealsubs:subscription_widget_created', function () {
    setTimeout(runAll, 0);
    setTimeout(runAll, 300);
  });
  setTimeout(runAll, 800);
  setTimeout(runAll, 1500);
  setTimeout(runAll, 3000);
  if (typeof MutationObserver !== 'undefined') {
    var docObs = new MutationObserver(function () {
      if (document.querySelector(FORM_SELECTOR)) {
        if (!document.querySelector(FORM_SELECTOR + '.' + ONE_TIME_CLASS)) init();
        runAll();
      }
    });
    docObs.observe(document.body, { childList: true, subtree: true });
  }
})();
